import { render, staticRenderFns } from "./StitchImageViewer.vue?vue&type=template&id=45c67ce0&scoped=true&"
import script from "./StitchImageViewer.vue?vue&type=script&lang=js&"
export * from "./StitchImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./StitchImageViewer.vue?vue&type=style&index=0&id=45c67ce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c67ce0",
  null
  
)

export default component.exports